import { StrictMode } from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';

import App from './components/App.js'
import './i18n/index.js'; 

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  // HTML statique détecté (prerendering) → hydratation
  hydrateRoot(
    rootElement,
    <StrictMode>
      <App />
    </StrictMode>
  );
} else {
  // Pas de HTML statique → rendu normal
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}